import { render, staticRenderFns } from "./CookiesSettings.vue?vue&type=template&id=11490622&scoped=true&"
import script from "./CookiesSettings.vue?vue&type=script&lang=js&"
export * from "./CookiesSettings.vue?vue&type=script&lang=js&"
import style0 from "./CookiesSettings.vue?vue&type=style&index=0&id=11490622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11490622",
  null
  
)

export default component.exports